module.exports = __webpack_public_path__ + "media/6.25b2bd0a.mp3";